import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { searchProfileKeys } from "@/lib/query-keys";
import type { OrganizationSearchProfile } from "@/types/domain";

/**
 * Todas las líneas de negocio de la empresa con sus asignados. Solo la puede leer
 * quien administra la cuenta; el resto del equipo usa `useSearchProfiles`, que
 * devuelve únicamente las suyas.
 */
export function useOrganizationSearchProfiles(enabled = true) {
  return useQuery({
    queryKey: searchProfileKeys.organization(),
    enabled,
    queryFn: () =>
      fetchToBackend<OrganizationSearchProfile[]>(
        "/searchprofiles/organization",
      ),
  });
}
